'use client'

import { useSearchParams } from 'next/navigation'

import JobsLandingPage from './JobsLandingPage'
import JobsSearchSection from './JobsSearchSection'
import JobsLayout from './JobsLayout'
import styles from '../jobs.module.scss'

type JobsPageContentProps = {
  categoriesSection?: React.ReactNode
  statesSection?: React.ReactNode
  ctaSection?: React.ReactNode
}

export default function JobsPageContent({ categoriesSection, statesSection, ctaSection }: JobsPageContentProps): JSX.Element {
  const searchParams = useSearchParams()
  
  const locationName = searchParams.get('location_name')
  const locationId = searchParams.get('location_id')
  
  // Show results if we have a location (query can be empty when navigating through category/state/county)
  const hasSearch = locationName || locationId

  // Show landing page if no search
  if (!hasSearch) {
    return (
      <>
        <JobsLandingPage />
        {categoriesSection}
        {statesSection}
        {ctaSection}
      </>
    )
  }

  // Show results page if search exists
  return (
    <>
      <JobsSearchSection />
      <main className={styles.jobsMainSection}>
        <div className={styles.jobsMainContainer}>
          <JobsLayout />
          <section className={styles.jobsPopularSection}>
            <h2 className={styles.jobsPopularTitle}>Popular job searches</h2>
            <div className={styles.jobsPopularTags}>
              <button className={styles.jobsPopularTag}>Full Time</button>
              <button className={styles.jobsPopularTag}>Cargo Vehicle Driver</button>
              <button className={styles.jobsPopularTag}>Specialist Nurse</button>
              <button className={styles.jobsPopularTag}>Healthcare Assistant</button>
              <button className={styles.jobsPopularTag}>Physiotherapist</button>
              <button className={styles.jobsPopularTag}>Social Worker</button>
              <button className={styles.jobsPopularTag}>Psychologist</button>
              <button className={styles.jobsPopularTag}>Customer Service Representative</button>
            </div>
          </section>
        </div>
      </main>
    </>
  )
}
